import { CreditCard, Building2, Link as LinkIcon, DollarSign } from 'lucide-react';

interface PaymentMethodChipProps {
  method: 'card' | 'spei' | 'link' | 'cash';
  cardLast4?: string; // Últimos 4 dígitos de tarjeta (opcional)
  variant?: 'default' | 'compact';
}

export const PaymentMethodChip = ({ 
  method, 
  cardLast4, 
  variant = 'default' 
}: PaymentMethodChipProps) => {
  const config = {
    card: {
      icon: CreditCard,
      label: cardLast4 ? `•••• ${cardLast4}` : 'Tarjeta',
      bg: 'bg-[#F7F8FA]',
      text: 'text-[#111827]',
      iconColor: 'text-[#6B7280]'
    },
    spei: {
      icon: Building2,
      label: 'SPEI',
      bg: 'bg-[#F7F8FA]',
      text: 'text-[#111827]',
      iconColor: 'text-[#6B7280]'
    },
    link: {
      icon: LinkIcon,
      label: 'Link de pago',
      bg: 'bg-[#F7F8FA]',
      text: 'text-[#111827]',
      iconColor: 'text-[#6B7280]'
    },
    cash: {
      icon: DollarSign,
      label: 'Efectivo',
      bg: 'bg-[#F7F8FA]',
      text: 'text-[#111827]',
      iconColor: 'text-[#6B7280]'
    }
  };

  const { icon: Icon, label, bg, text, iconColor } = config[method];

  if (variant === 'compact') {
    return (
      <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-[6px] ${bg} ${text} text-xs font-medium`}>
        <Icon className={`w-3.5 h-3.5 ${iconColor}`} />
        {label}
      </span>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-[8px] ${bg}`}>
      <Icon className={`w-4 h-4 ${iconColor}`} />
      <div>
        <p className={`text-sm font-semibold ${text}`}>{label}</p>
        {method === 'card' && !cardLast4 && (
          <p className="text-xs text-[#6B7280]">Tarjeta</p>
        )}
      </div>
    </div>
  );
};
